var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSessionBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_7878_166730)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3346 12.6666V10.3333C19.3346 9.39987 19.3346 8.93316 19.153 8.57664C18.9932 8.26304 18.7382 8.00807 18.4246 7.84828C18.0681 7.66663 17.6014 7.66663 16.668 7.66663H10.3346C9.40121 7.66663 8.9345 7.66663 8.57798 7.84828C8.26438 8.00807 8.00941 8.26304 7.84962 8.57664C7.66797 8.93316 7.66797 9.39987 7.66797 10.3333V16.6666C7.66797 17.6 7.66797 18.0668 7.84962 18.4233C8.00941 18.7369 8.26438 18.9918 8.57798 19.1516C8.9345 19.3333 9.40121 19.3333 10.3346 19.3333H12.668M16.0013 18.5L17.668 20.1666L21.418 16.4166M15.3346 24.3333H21.668C22.6014 24.3333 23.0681 24.3333 23.4246 24.1516C23.7382 23.9918 23.9932 23.7369 24.153 23.4233C24.3346 23.0668 24.3346 22.6 24.3346 21.6666V15.3333C24.3346 14.3999 24.3346 13.9332 24.153 13.5766C23.9932 13.263 23.7382 13.0081 23.4246 12.8483C23.0681 12.6666 22.6014 12.6666 21.668 12.6666H15.3346C14.4012 12.6666 13.9345 12.6666 13.578 12.8483C13.2644 13.0081 13.0094 13.263 12.8496 13.5766C12.668 13.9332 12.668 14.3999 12.668 15.3333V21.6666C12.668 22.6 12.668 23.0668 12.8496 23.4233C13.0094 23.7369 13.2644 23.9918 13.578 24.1516C13.9345 24.3333 14.4012 24.3333 15.3346 24.3333Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7878_166730",
    x1: 29.5,
    y1: 27,
    x2: 3.5,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F67F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionBlue);
export default __webpack_public_path__ + "static/media/session-blue.4dadac488649eb758498397e840503d3.svg";
export { ForwardRef as ReactComponent };